// frontend/src/content/reiki-de.js
// All German copy for the Reiki website.
// Import this file into components — never hardcode strings.

export const meta = {
  title: "Reiki Sessions — Benjamin Kurtz",
  description:
    "Reiki Sessions mit Benjamin Kurtz. Energiearbeit, Heilung und Balance — online oder vor Ort.",
};

// ═══════════════════════════════════════════════════════════
// HEADER
// ═══════════════════════════════════════════════════════════
export const header = {
  nav: [
    { label: "Was ist Reiki?", anchor: "#was-ist" },
    { label: "Für wen?", anchor: "#fuer-wen" },
    { label: "Ablauf", anchor: "#prozess" },
    { label: "Über Benjamin", anchor: "#ueber" },
    { label: "Erfahrungen", anchor: "#cases" },
  ],
  cta: "Termin buchen",
};

// ═══════════════════════════════════════════════════════════
// HeroV3Section — HERO
// ═══════════════════════════════════════════════════════════
export const hero = {
  label: "BENJAMIN KURTZ ACADEMY",
  headlineLine1: "Reiki öffnet",
  headlineLine2: "dein Herz.",
  heroCta: "Bist du bereit für Heilung?",
  subline: "Reiki · Energiearbeit · Ausgleich — online und im Präsenz bei dir.",
  ctaPrimary: "Reiki-Session buchen",
  ctaSecondary: "Mehr erfahren →",
  videoPlaceholder: "[ Reiki-Video Benjamin Kurtz ]",
  videoUrl: "",
  posterUrl: "",
  vimeoEmbedUrl: "",
};

// ═══════════════════════════════════════════════════════════
// ServicesSection — SERVICES
// ═══════════════════════════════════════════════════════════
export const services = {
  items: [
    { label: "Reiki Healing", sub: "Universelle Lebensenergie" },
    { label: "Chakra-Ausgleich", sub: "Energiezentren harmonisieren" },
    { label: "Fernheilung", sub: "Reiki auf Distanz" },
  ],
  location: "online & vor Ort",
};

// ═══════════════════════════════════════════════════════════
// WelcomeSection — WELCOME
// ═══════════════════════════════════════════════════════════
export const welcome = {
  headline: "Hi, ich bin Benjamin.\nSchön, dass du hier bist.",
  quoteLines: [
    "Hier erfährst du, was Reiki ist, wie es dir helfen kann, Blockaden zu lösen und deinen Energiefluss wiederherzustellen.",
    "Als Reiki-Master (Usui) begleite ich dich auf deinem Weg zu mehr Balance, Heilung und innerem Frieden.",
    "Ich freu mich von dir zu hören. Viel Freude.",
  ],
  author: "Benjamin",
  imageUrl: "https://media.thelightcall.com/images/2%20s%20350px.png",
  signatureUrl: "https://media.thelightcall.com/images/signature_benjamin_black.png",
};

// ═══════════════════════════════════════════════════════════
// StatementSection — STATEMENT
// ═══════════════════════════════════════════════════════════
export const statement = {
  lines: [
    "Reiki ist nicht nur eine Methode.",
    "Es ist ein Weg zu dir selbst.",
    "Heilung beginnt mit Berührung.",
  ],
};

// ═══════════════════════════════════════════════════════════
// WhatIsSection — WHAT IS REIKI
// ═══════════════════════════════════════════════════════════
export const whatIs = {
  label: "REIKI SESSIONS",
  headline: "Was bedeutet Reiki und wie wirkt es?",
  body: [
    "Reiki (japanisch 霊気) bedeutet 'universelle Lebensenergie' — eine sanfte, aber kraftvolle Heilungstechnik, die durch Handauflegen über und am Körper angewendet wird.",
    "Die Wurzeln liegen im alten Japan, entdeckt von Dr. Mikao Usui im frühen 20. Jahrhundert. Reiki wirkt auf körperlicher, emotionaler, mentaler und spiritueller Ebene.",
    "Während einer Reiki-Session fließt die Energie durch die Hände des Praktizierten zum Empfänger. Dieser entspannt sich tief, während Blockaden gelöst und der Energiefluss harmonisiert wird.",
    "Reiki ist kein Glaube, sondern eine Erfahrung. Du musst nichts verstehen, um zu heilen. Die Energie weiß, wo sie gebraucht wird.",
  ],
};

// ═══════════════════════════════════════════════════════════
// ForWhomSection — FOR WHOM
// ═══════════════════════════════════════════════════════════
export const forWhom = {
  label: "FÜR WEN",
  headline: "Wer kommt zu einer Reiki-Session?",
  intro:
    "Reiki ist für alle Menschen geeignet, die nach Balance, Heilung und Unterstützung suchen. Es ist sanft, nicht-invasiv und wirkt unterstützend bei vielen Themen.",
  topics: [
    { title: "Stress & Burnout", body: "Wenn der Akku leer ist und nichts mehr geht." },
    { title: "Schlafstörungen", body: "Wenn der Schlaf nicht kommen will." },
    { title: "Körperliche Schmerzen", body: "Energiearbeit zur Unterstützung der Heilung." },
    { title: "Emotionale Blockaden", body: "Wenn Gefühle feststecken." },
    { title: "Lebenskrisen", body: "Bei Veränderung, Verlust, Neuorientierung." },
    { title: "Energetischer Ausgleich", body: "Nach Krankheit, Operation oder Erschöpfung." },
    { title: "Spirituelle Entwicklung", body: "Verbindung zu höherer Energie." },
    { title: "Selbstliebe & Akzeptanz", body: "Heilung des inneren Kindes." },
  ],
};

// ═══════════════════════════════════════════════════════════
// AboutSection — ABOUT BENJAMIN
// ═══════════════════════════════════════════════════════════
export const about = {
  label: "ÜBER BENJAMIN KURTZ",
  headline: "Was mich zu Reiki geführt hat",
  body: [
    "Mein Weg zu Reiki begann mit einer tiefen persönlichen Erfahrung. Nach Jahren der Begleitung anderer Menschen suchte ich nach einer Methode, die sanft und dennoch kraftvoll ist — eine Energiearbeit, die ohne Worte wirkt.",
    "Als Reiki-Master (Usui) habe ich Menschen auf ihrem Heilungsweg begleitet — bei körperlichen Beschwerden, emotionalen Blockaden, spirituellen Krisen. Reiki hat sich als einer der wirksamsten Wege erwiesen, Balance wiederherzustellen und den Körper zur Selbstheilung zu aktivieren.",
  ],
  credentials: [
    "Reiki Master Teacher (Usui)",
    "Quanten-Heilung",
    "Energiearbeit & Chakra-Balance",
    "NLP Master & NR Practitioner",
    "Hypnose-Coach",
    "Breathwork & Meditation",
  ],
  credentialsLabel: "AUSBILDUNGEN & ZERTIFIZIERUNGEN",
  photoPlaceholder: "[ Foto Benjamin Kurtz ]",
};

// ═══════════════════════════════════════════════════════════
// ProcessSection — PROCESS
// ═══════════════════════════════════════════════════════════
export const processSection = {
  label: "DER PROZESS",
  headline: "Von unserer ersten Begegnung bis zur Integration",
  steps: [
    {
      number: "01",
      title: "Kennenlernen",
      duration: "Kostenlos · 15 Minuten",
      body: "Ein kurzes Gespräch, um zu schauen, ob die Chemie stimmt und Reiki der richtige Weg für dich ist.",
    },
    {
      number: "02",
      title: "Die Session",
      duration: "60 Minuten · 1:1 online oder vor Ort",
      body: "Du liegst entspannt, während ich Reiki durch Handauflegen oder auf Distanz übertrage. Du entspannst dich tief.",
    },
    {
      number: "03",
      title: "Nachsorge",
      duration: "Optional · 5–10 Minuten",
      body: "Nach der Session hast du Zeit, das Erlebte wirken zu lassen. Wir können kurz über deine Erfahrungen sprechen.",
    },
  ],
  footnote:
    "Viele Klienten kommen regelmäßig zu Reiki-Sessions — zur Prävention, zur Unterstützung, oder einfach um sich selbst zu赠nen.",
  cta: "Reiki-Session buchen",
};

// ═══════════════════════════════════════════════════════════
// TestimonialsSection — TESTIMONIALS
// ═══════════════════════════════════════════════════════════
export const testimonials = {
  clientLabel: "ERFAHRUNGEN",
  clientSubtitle: "Was Klienten berichten",
  clients: [
    {
      quote: "Die Reiki-Session war unglaublich entspannend. Ich spürte ein warmes Fließen durch meinen ganzen Körper. Nachher war ich wie neugeboren.",
      name: "Maria S.",
      context: "Lehrerin, Deutschland",
      image: "",
    },
    {
      quote: "Ich war erst skeptisch — aber die Energie, die ich spürte, war real. Mein Schlaf hat sich seitdem deutlich verbessert.",
      name: "Thomas K.",
      context: "Unternehmer, Österreich",
      image: "",
    },
  ],
};

// ═══════════════════════════════════════════════════════════
// BookingSection — BOOKING
// ═══════════════════════════════════════════════════════════
export const booking = {
  label: "BEREIT FÜR HEILUNG?",
  headline: "Reiki-Session buchen.",
  subline:
    "Kostenlos und unverbindlich. Wir schauen gemeinsam, was dich bewegt — und ob eine Session der nächste sinnvolle Schritt ist.",
  formPlaceholder: "[ Fluent Forms Embed ]",
  directBookingText: "Du willst direkt einen Termin wählen?",
  directBookingCta: "Reiki-Session buchen",
  directBookingUrl: "https://www.benjaminkurtz.de/bookings/reiki",
  formTopics: [
    "Stress & Burnout",
    "Schlafstörungen",
    "Körperliche Schmerzen",
    "Emotionale Blockaden",
    "Energetischer Ausgleich",
    "Spirituelle Entwicklung",
  ],
};

// ═══════════════════════════════════════════════════════════
// FAQSection — FREQUENTLY ASKED QUESTIONS
// ═══════════════════════════════════════════════════════════
export const faq = {
  bigLabel: "FRAGEN & ANTWORTEN",
  headline: "Häufige Fragen zu Reiki",
  items: [
    {
      question: "Was ist Reiki?",
      answer: `Reiki ist eine japanische Heilungstechnik, die 'universelle Lebensenergie' bedeutet. Durch Handauflegen wird Energie übertragen, die den Körper bei der Selbstheilung unterstützt. Reiki wirkt auf körperlicher, emotionaler, mentaler und spiritueller Ebene.`,
    },
    {
      question: "Kann ich Reiki auch online erhalten?",
      answer: `Ja. Reiki ist nicht an Ort und Zeit gebunden — Energie fließt auch auf Distanz. Fernheilung ist genauso wirksam wie vor Ort. Viele Klienten berichten von ähnlichen oder sogar tieferen Erfahrungen in Online-Sessions.`,
    },
    {
      question: "Was fühlt man während einer Session?",
      answer: `Die Erfahrungen sind unterschiedlich. Manche spüren Wärme, Kälte, Kribbeln, ein sanftes Pulsieren. Andere entspannen sich einfach tief und rutschen fast in einen Schlafzustand. Alles ist normal und richtig.`,
    },
    {
      question: "Gibt es Nebenwirkungen?",
      answer: `Reiki ist sanft und sicher. Manchmal kann es zu einer sogenannten 'Heilungskrise' kommen — alte Emotionen kommen hoch, Symptome verstärken sich kurzzeitig. Das ist ein Zeichen dafür, dass der Körper heilt. Trink viel Wasser, ruhe dich aus.`,
    },
  ],
};

// ═══════════════════════════════════════════════════════════
// FOOTER
// ═══════════════════════════════════════════════════════════
export const footer = {
  brand: "Benjamin Kurtz Academy LLC",
  tagline: "Healing Energy\nAligned with Your Soul",
  contactLabel: "Kontaktiere uns:",
  legalLabel: "Rechtliches",
  followLabel: "Folgen",
  disclaimerTitle: "Rechtlicher Hinweis",
  disclaimer: `Reiki ist eine komplementärmedizinische Methode und ersetzt keine ärztliche Behandlung. Bei gesundheitlichen Beschwerden wende dich bitte an einen Arzt oder Heilpraktiker. Reiki unterstützt die Selbstheilungskräfte, ist aber keine Heilversprechen.`,
  introCallLabel: "Erstgespräch",
  copyright: {
    prefix: "Alle Rechte vorbehalten. Home:",
    homeLabel: "benjaminkurtz.de",
    homeUrl: "https://benjaminkurtz.de",
  },
  contact: [
    { label: "WhatsApp",  url: "https://wa.me/4915121231244",           icon: "whatsapp"  },
    { label: "E-Mail",    url: "mailto:hello@benjaminkurtz.de",          icon: "mail"      },
    { label: "Instagram", url: "https://instagram.com/benjaminkurtz_de", icon: "instagram" },
  ],
  legalLinks: [
    { label: "Terms",   url: "https://www.benjaminkurtz.de/terms/"   },
    { label: "Privacy", url: "https://www.benjaminkurtz.de/privacy/" },
    { label: "Imprint", url: "https://www.benjaminkurtz.de/imprint/" },
  ],
  social: [
    { label: "Instagram", url: "https://instagram.com/benjaminkurtz_de" },
    { label: "YouTube",   url: "https://youtube.com/@benjaminkurtz" },
  ],
};

// ═══════════════════════════════════════════════════════════
// UI LABELS (Global UI text strings)
// ═══════════════════════════════════════════════════════════
export const ui = {
  showMore: "Mehr",
  showLess: "Weniger",
};

// ═══════════════════════════════════════════════════════════
// NotFoundPage — 404 PAGE CONTENT
// ═══════════════════════════════════════════════════════════
export const notFound = {
  brandName: "Benjamin Kurtz",
  title: "Seite nicht gefunden",
  message: "Die Seite, die du suchst, existiert nicht oder wurde verschoben. Lass uns zurück nach Hause gehen.",
  homeButtonLabel: "Zur Startseite",
  homeAriaLabel: "Zur Startseite",
  homeButtonAriaLabel: "Zur Startseite",
};

// Default export for backwards compatibility
export default {
  meta, header, hero, services, welcome, statement, whatIs,
  forWhom, about, processSection, testimonials, booking, faq, footer, ui, notFound,
}
